export default __webpack_public_path__ + "static/media/map_shell.89f38557.png";